import { useAtom } from 'jotai';

import { Banner } from '@flintmint/web-shared/components/banner';

import { useOpenAiRefusalInvitation } from '@/features/billing/ai-refusal-invitation/ai-refusal-invitation';
import { getEnergyView, isTrialEnergyUsedUp } from '@/features/llm-chat/energy/energy-view';
import { urlOverlays } from '@/constants/url-overlays';
import { useUrlOverlay } from '@/hooks/use-url-overlay';
import { useUserAccount } from '@/hooks/use-user-account';
import { trialEnergyBannerDismissedAtom } from '@/state';

/**
 * Asks a Trial whose early start is held to complete its payment, at any Trial Energy level and with no close
 * control. Otherwise tells a Trial whose Energy is used up that it is still active, and opens the choices for
 * starting its plan.
 */
export const TrialEnergyBanner = () => {
  const { account } = useUserAccount();
  const [dismissed, setDismissed] = useAtom(trialEnergyBannerDismissedAtom);
  const openInvitation = useOpenAiRefusalInvitation();
  const { open: openStartPlan } = useUrlOverlay(urlOverlays.startPlan, urlOverlays);

  if (getEnergyView(account)?.action === 'payHeldCharge') {
    return (
      <Banner
        type="neutral"
        title="Your early start needs payment"
        message="Your Trial and remaining Energy are unchanged. Complete payment to start your paid plan."
        action={{ label: 'Complete payment', onClick: openStartPlan }}
      />
    );
  }

  if (dismissed || !isTrialEnergyUsedUp(account)) return null;

  return (
    <Banner
      type="neutral"
      title="Your Trial is still active"
      message="Your Trial Energy is used up. Start your subscription now, or cancel the scheduled subscription and keep using Free."
      onClose={() => setDismissed(true)}
      action={{ label: 'Review options', onClick: openInvitation }}
    />
  );
};
